import api from "app/lib/api";
import endpoints from "static/endpoints";

export const getRevenueAnalytic = async () => {
  const { data } = await api.get(endpoints.dashboard.revenueAnalytic);

  return data;
};
